<template>
  <nav class="navbar container is-transparent">
    <div class="navbar-brand">
      <router-link class="navbar-item" :to="{ path: $root.isLoggedIn ? '/dashboard' : '/' }">
        <img src="@/assets/logo_mini.png" alt="Biaggeo">
      </router-link>
      <div class="navbar-burger burger" data-target="navbarExampleTransparentExample">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div id="navbarExampleTransparentExample" class="navbar-menu">
      <div class="navbar-start">
        <router-link class="navbar-item" :to="{ path: '/' }" v-if="!$root.isLoggedIn"><mark>Home</mark></router-link>
        <router-link class="navbar-item" :to="{ path: '/dashboard' }" v-if="$root.isLoggedIn"><mark>Dashboard</mark></router-link>
        <router-link class="navbar-item" :to="{ path: '/project/1' }">project/1</router-link>
        <router-link class="navbar-item" :to="{ path: '/user/jschmoe' }">user/jschmoe</router-link>
        <router-link class="navbar-item" :to="{ path: '/u/clarkson' }">u/clarkson</router-link>
        <!-- <router-link class="navbar-item" :to="{ path: '/help' }"><mark>help</mark></router-link> -->
      </div>

      <div class="navbar-end">

          <!-- Create project -->
          <router-link v-if="$root.isLoggedIn && $root.user.accountType === 'student'" class="navbar-item" :to="{ path: '/createProject'}">Create a project</router-link>

          <!-- University -->
          <router-link v-if="$root.isLoggedIn" class="navbar-item" :to="universitySlug">{{$root.user.university.name}}</router-link>

          <!-- Profile -->
          <router-link v-if="$root.isLoggedIn" class="navbar-item" :to="profileSlug">
              <figure class="image profile">
                <img :src="$root.user.image[0].sizes.circularList" class="is-rounded" /> <!-- nav icon isn't being generated by Sharp properly... -->
              </figure>
              <span>&nbsp;{{$root.user.firstName}}</span>
          </router-link>

          <!-- Actions (login/logout/register) -->
          <div class="navbar-item">
            <router-link v-if="!$root.isLoggedIn" class="navbar-item" :to="{ path: '/register' }">Register</router-link>
            <router-link v-if="!$root.isLoggedIn" class="button is-primary is-outlined" :to="{ path: '/login' }">Login</router-link>
            <a v-if="$root.isLoggedIn" class="button is-primary is-outlined" @click="$root.logout">Logout</a>
          </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Nav',
  data () {
    return {}
  },
  computed: {
    universitySlug: function() {
        return '/u/' + this.$root.user.university.slug;
    },
    profileSlug: function() {
        return '/user/' + this.$root.user.username;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Nav.vue